import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, IFailureAction } from "interfaces/update-duck";

const { Types, Creators } = createActions(
  {
    request: ["id", "putData", "onSuccess", "onFailure"],
    success: [],
    failure: ["error"],
    reset: [],
  },
  { prefix: "REPLY_JUSTIFICATION_" }
);

export interface ReplyJustificationState extends IState {}

const INITIAL_STATE: ReplyJustificationState = {
  loading: false,
  error: null,
};

const request = (state: ReplyJustificationState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: ReplyJustificationState) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (state: ReplyJustificationState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const replyJustification = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ReplyJustificationTypes = Types;
export const ReplyJustificationActions = Creators;
